import { useCallback } from 'react';
import { IPoiFilterType, PoiFilterOption } from '../models/PoiFilterOption';
import { PoiOpeningHours } from '../models/PoiOpeningHours';
import { PoiSecurityZoneItems } from '../models/PoiSecurityZone';

export const useFilterHandlers = (
	setLocation: (location: string) => void,
	setOpeningHours: (openingHours: PoiOpeningHours) => void,
	setSecurityZone: (securityZone: PoiSecurityZoneItems) => void,
	setType: (type: string) => void,
) => {
	const onSelectFilter = useCallback(
		(filterOption: PoiFilterOption, selectedItem: IPoiFilterType) => {
			switch (filterOption) {
				case PoiFilterOption.Location:
					setLocation(selectedItem);
					break;
				case PoiFilterOption.OpeningHours:
					setOpeningHours(selectedItem as PoiOpeningHours);
					break;
				case PoiFilterOption.SecurityZone:
					setSecurityZone(selectedItem as PoiSecurityZoneItems);
					break;
				case PoiFilterOption.Types:
					setType(selectedItem);
					break;
				default:
					break;
			}
		},
		[setLocation, setOpeningHours, setSecurityZone, setType],
	);

	return { onSelectFilter };
};
